import { lazy, Suspense } from 'react';
import { RouteObject } from 'react-router-dom';
import NotFound from "../pages/NotFound";
import { Loader, EnRedirect, RequestQuoteRedirect } from "./components";

const HomePage = lazy(() => import("../pages/home/page"));
const AboutPage = lazy(() => import("../pages/about/page"));
const OurBusinessPage = lazy(() => import("../pages/our-business/page"));
const MissionStatementPage = lazy(() => import("../pages/mission-statement/page"));
const ContactPage = lazy(() => import("../pages/contact/page"));
const ProductListPage = lazy(() => import("../pages/product-list/page"));
const PurchasingProcessPage = lazy(() => import("../pages/purchasing-process/page"));
const ImportExportTermsPage = lazy(() => import("../pages/import-export-terms/page"));
const ChemicalTradeInfoPage = lazy(() => import("../pages/chemical-trade-info/page"));
const NewsPage = lazy(() => import("../pages/news/page"));
const NewsDetailPage = lazy(() => import("../pages/news-detail/page"));
const InformationSecurityPolicyPage = lazy(() => import("../pages/information-security-policy/page"));
const SitePolicyPage = lazy(() => import("../pages/site-policy/page"));
const PrivacyPolicyPage = lazy(() => import("../pages/privacy-policy/page"));

const routes: RouteObject[] = [
  { path: '/', element: <Suspense fallback={<Loader />}><HomePage /></Suspense> },
  { path: '/product-list', element: <Suspense fallback={<Loader />}><ProductListPage /></Suspense> },
  { path: '/purchasing-process', element: <Suspense fallback={<Loader />}><PurchasingProcessPage /></Suspense> },
  { path: '/mission-statement', element: <Suspense fallback={<Loader />}><MissionStatementPage /></Suspense> },
  { path: '/our-business', element: <Suspense fallback={<Loader />}><OurBusinessPage /></Suspense> },
  { path: '/about', element: <Suspense fallback={<Loader />}><AboutPage /></Suspense> },
  { path: '/contact', element: <Suspense fallback={<Loader />}><ContactPage /></Suspense> },
  // 見積依頼ページは削除した（Issue #15）。サイト内に導線が無く、見積の入口は
  // すべて /contact?type=quote に向いていたため。直リンク・被リンク対策として転送のみ残す。
  { path: '/request-quote', element: <RequestQuoteRedirect /> },
  { path: '/chemical-trade-info', element: <Suspense fallback={<Loader />}><ChemicalTradeInfoPage /></Suspense> },
  { path: '/news', element: <Suspense fallback={<Loader />}><NewsPage /></Suspense> },
  { path: '/news/:id', element: <Suspense fallback={<Loader />}><NewsDetailPage /></Suspense> },
  { path: '/import-export-terms', element: <Suspense fallback={<Loader />}><ImportExportTermsPage /></Suspense> },
  { path: '/information-security-policy', element: <Suspense fallback={<Loader />}><InformationSecurityPolicyPage /></Suspense> },
  { path: '/site-policy', element: <Suspense fallback={<Loader />}><SitePolicyPage /></Suspense> },
  { path: '/privacy-policy', element: <Suspense fallback={<Loader />}><PrivacyPolicyPage /></Suspense> },
  { path: '/en', element: <EnRedirect /> },
  { path: '/en/*', element: <EnRedirect /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
